import { render, staticRenderFns } from "./checkRoleDialog.vue?vue&type=template&id=54ef6c4e&scoped=true"
import script from "./checkRoleDialog.vue?vue&type=script&lang=js"
export * from "./checkRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef6c4e",
  null
  
)

export default component.exports